import { useContext, useState } from 'react';
import { UserContext } from "../../context/user-context";
import FormInput from '../../components/form-input';
import Button from '../../components/button';
import { createLog, updateUserDocument } from '../../utils/firebase';
import {useNavigate} from 'react-router-dom';

const VoluntaryWork = () => {
    const { currentUser } = useContext(UserContext);
    const [formFields, setFormFields] = useState({voluntary: currentUser["data"]["voluntary"] ? currentUser["data"]["voluntary"] : []});
    const navigate = useNavigate();
    const { voluntary } = formFields;

    const handleChange = (index, event) => {
        const { id, value } = event.target;
        voluntary[index][id] = value;

        setFormFields({...formFields});
    }

    const handleOnAdd = () => {
        voluntary.push({
            "from" : "",
            "to" : "",
            "organization": "",
            "hours": "",
            "position": "",
        });

        setFormFields({...formFields});
    }

    const handleOnRemove = (index) => {
        voluntary.splice(index, 1);

        setFormFields({...formFields});
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const response = await updateUserDocument(currentUser["uid"], formFields);
        if (response === "success") {
            const log = {"action": "User updated PDS voluntary work", "by" : currentUser.uid}
            await createLog(log);

            Object.assign(currentUser["data"], formFields);
        }
        alert(response);
    }

    return (
        <div className='column'>
            <div className='columns main'>
                <div className='column is-8 is-offset-2'>
                    <h2 className='is-size-2 has-text-weight-bold my-6'>Voluntary Work</h2>
                    <form onSubmit={handleSubmit}>
                        {voluntary.map((work, index) => {
                            return (
                                <div className='block' key={index}>
                                    <div className='columns is-vcentered'>
                                        <FormInput type="text" required id="organization" value={work["organization"]} onChange={(e) => handleChange(index, e)} label="Name & Address of Organization" additionalClasses="column is-10"/>
                                        <div className='column is-1' style={{marginTop: "22px"}}><button type='button' onClick={() => handleOnRemove(index)} className="delete is-large"></button></div>
                                    </div>
                                    
                                    <div className='columns'>
                                        <FormInput type="date" required id="from" value={work["from"]} onChange={(e) => handleChange(index, e)} label="From" additionalClasses="column is-5"/>
                                        <FormInput type="date" required id="to" value={work["to"]} onChange={(e) => handleChange(index, e)} label="To" additionalClasses="column is-5"/>
                                    </div>
                                    <div className='columns'>
                                        <FormInput type="number" id="hours" value={work["hours"]} onChange={(e) => handleChange(index, e)} label="No. of Hours" additionalClasses="column is-5"/>
                                        <FormInput type="text" id="position" value={work["position"]} onChange={(e) => handleChange(index, e)} label="Position/Nature of Work" additionalClasses="column is-5"/>
                                    </div>
                                </div>
                            )
                        })}
                        <Button additionalClasses="block mr-4" type="button" onClick={handleOnAdd}>Add Voluntary Work</Button>
                        <Button additionalClasses="block is-success" type="submit">Submit</Button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default VoluntaryWork;